import script from "./AccessDeniedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AccessDeniedModal.vue?vue&type=script&setup=true&lang=js"

import "./AccessDeniedModal.vue?vue&type=style&index=0&id=4c9fa6a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c9fa6a4"]])

export default __exports__